import { getCLS, getFID, getLCP } from 'web-vitals';
import { trackWebVital } from './matomo';

function reportMetric(metric) {
  trackWebVital(metric.name, metric.value, window.location.pathname);
}

export function reportWebVitalsToMatomo() {
  getLCP(reportMetric);
  getCLS(reportMetric);
  getFID(reportMetric);
}
